module.exports = __webpack_public_path__ + "static/media/faq.de8cc2dc.svg";